import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class AddVolunteers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            textInput: "",
            userName: "",
            name: "",
            category: "",
            areaInput: "",
            categoryData: [],
            city: "",
            designation: "",
            contactNo: '',
            pincode: "",
            iscontactNoValid: true,
            ispincodeValid: true,
            submissionStatus: null,
            currentImageUrl: null,
            submeet: false,
            errors: [],
            maxSize: 5 * 1024 * 1024, // 5MB in bytes
            imageFile: null // State to hold the image file
        };
    }

    handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > this.state.maxSize) {
                alert('File size exceeds the 5MB limit.');
                this.setState({ imageFile: null });
            } else {
                this.setState({ imageFile: file });
            }
        }
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ submeet: true });

        const { name, areaInput, contactNo, designation, imageFile } = this.state;
        const formData = new FormData();
        formData.append('name', name);
        formData.append('city', areaInput);
        formData.append('contactNo', contactNo);
        formData.append('designation', designation);
        if (imageFile) formData.append('image', imageFile);

        try {
            const response = await axios.post("https://samaj.aasmo.in/api/admin/volunteers", formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status === 201) {
                this.setState({ submissionStatus: 'success', submeet: false });
                setTimeout(() => {
                 this.props.history.push("/volunteersorcommittee");
                }, 2000);
            }
        } catch (error) {
            console.log(error);
            this.setState({ submissionStatus: 'error' });
        }
    };

    render() {
        const { name, contactNo, areaInput, designation, submissionStatus, submeet, imageFile } = this.state;
        const isNameValid = name.trim().length > 0;
        const isContactNoValid = contactNo.trim().length > 0;
        const isDesignationValid = designation.trim().length > 0;
        const isCityValid = areaInput?.trim().length > 0;

        return (
            <div className="col-md-12">
                <div className="card">
                    <div className="header">
                        <h2>Add Volunteers or Committee</h2>
                    </div>
                    <div className="body">
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                                    value={name}
                                    name="name"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value });
                                    }}
                                />
                                {!isNameValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Contact No</label>
                                <input
                                    className={`form-control ${!isContactNoValid && submeet && "parsley-error"}`}
                                    value={contactNo}
                                    name="contactNo"
                                    required=""
                                    type="number"
                                    onChange={(e) => {
                                        this.setState({ contactNo: e.target.value });
                                    }}
                                />
                                {!isContactNoValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>City</label>
                                <textarea
                                    className={`form-control ${areaInput === "" && submeet && "parsley-error"}`}
                                    value={areaInput}
                                    cols="30"
                                    name="textarea"
                                    required=""
                                    rows="5"
                                    onChange={(e) => {
                                        this.setState({ areaInput: e.target.value });
                                    }}
                                ></textarea>
                                {areaInput === "" && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Designation</label>
                                <input
                                    className={`form-control ${!isDesignationValid && submeet && "parsley-error"}`}
                                    value={designation}
                                    name="designation"
                                    required=""
                                    type="text"
                                    onChange={(e) => {
                                        this.setState({ designation: e.target.value });
                                    }}
                                />
                                {!isDesignationValid && submeet ? (
                                    <ul className="parsley-errors-list filled">
                                        <li className="parsley-required">
                                            This value is required.
                                        </li>
                                    </ul>
                                ) : null}
                            </div>

                            <div className="form-group">
                                <label>Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    accept="image/*"
                                    onChange={this.handleImageChange}
                                />
                                {imageFile && (
                                    <div className="mt-2">
                                        <img
                                            src={URL.createObjectURL(imageFile)}
                                            alt="Preview"
                                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                                        />
                                    </div>
                                )}
                            </div>

                            {submissionStatus === 'success' && (
                                <div className="alert alert-success" role="alert">
                                    Form submitted successfully!
                                </div>
                            )}

                            <button className="btn btn-primary" type="submit">
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter (connect(mapStateToProps, { notifyGeneralInfo })(AddVolunteers));
